import React, { Component } from 'react'

// Wrapper pour ajouter les attributs d'accessibilité aux composants react-share
// Les composants react-share ne transmettent pas directement title et aria-label aux éléments DOM
class AccessibleShareButton extends Component {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    this.addAccessibilityAttributes();
  }

  componentDidUpdate() {
    this.addAccessibilityAttributes();
  }

  addAccessibilityAttributes() {
    if (this.wrapperRef.current) {
      // react-share génère généralement un div avec role="button"
      const buttonElement = this.wrapperRef.current.querySelector('[role="button"]');
      
      if (buttonElement) {
        if (this.props['aria-label']) {
          buttonElement.setAttribute('aria-label', this.props['aria-label']);
        }
        if (this.props.title) {
          buttonElement.setAttribute('title', this.props.title);
        }
      }
    }
  }

  render() {
    const { ShareButton, 'aria-label': ariaLabel, title, ...shareProps } = this.props;
    
    return (
      <div ref={this.wrapperRef} className="SocialMediaShareButton">
        <ShareButton {...shareProps} />
      </div>
    );
  }
}

export default AccessibleShareButton

